import * as jsxRuntime from "C:\\Users\\gusut\\work\\app_pilot\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment